import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export type EntryValueChipToneT = "neutral" | "positive" | "muted";

interface EntryValueChipProps {
    icon?: LucideIcon;
    tone?: EntryValueChipToneT;
    size?: "sm" | "md" | "lg";
    children: ReactNode;
}

const iconClassName: Record<EntryValueChipToneT, string> = {
    neutral: "text-primary",
    positive: "text-primary",
    muted: "text-slate-400 dark:text-slate-500",
};

/** Read-only value box styled like the number entry value, with an optional leading icon. */
export function EntryValueChip({ icon: Icon, tone = "neutral", size = "md", children }: EntryValueChipProps) {
    return (
        <span className="flex items-center gap-2 bg-white/80 px-3 py-1 border border-slate-200 rounded-md w-fit">
            {Icon && (
                <Icon
                    aria-hidden
                    className={cn(
                        "shrink-0",
                        size === "sm" ? "size-3.5" : size === "lg" ? "size-5" : "size-4",
                        iconClassName[tone]
                    )}
                />
            )}
            <span
                className={cn(
                    "flex items-baseline gap-1 font-medium text-slate-900 dark:text-slate-200",
                    size === "sm" ? "text-sm" : size === "lg" ? "text-xl" : "text-md"
                )}
            >
                {children}
            </span>
        </span>
    );
}
